export default {
  /**
   * 获取指定日期剩下的天数
   * @param date 指定的日期,格式为yyyy-MM-dd
   */
  getRestDays: function (date) {
    var nowDate = new Date()
    var year = nowDate.getFullYear();
    var month = nowDate.getMonth() + 1;
    var day = nowDate.getDate();
    var sDate1 = year + "-" + month + "-" + day;
    var aDate, oDate1, oDate2, iDays;
    aDate = sDate1.split("-");
    oDate1 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]); //转换为yyyy-MM-dd格式
    aDate = date.split("-");
    oDate2 = new Date(aDate[1] + '-' + aDate[2] + '-' + aDate[0]);
    iDays = parseInt(Math.abs(oDate1 - oDate2) / 1000 / 60 / 60 / 24); //把相差的毫秒数转换为天数
    return iDays; //返回相差天数
  },

  // 时间戳转日期
  timeToDate(data, type) {
    if (!data) {
      return ''
    }
    if (data.length == 10) {
      data = data * 1000;
    } else {
      data = data * 1;
    }
    var d = new Date(data); //时间戳记得乘以1000再进行处理
    var year = d.getFullYear();
    var month = d.getMonth() + 1 < 10 ? '0' + (d.getMonth() + 1) : d.getMonth() + 1;
    var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
    var h = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
    var mm = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
    var s = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
    if (type == 1) {
      return year + "-" + month + "-" + day + ' ' + h + ':' + mm + ':' + s;
    } else if (type == 2) {
      return year + "." + month + "." + day;
    } else if (type == 3) {
      return year + "/" + month + "/" + day + ' ' + h + ':' + mm;
    } else {
      return year + "-" + month + "-" + day;
    }
  },


  /***
   * oss图片固定尺寸转换
   * typeImg(1:我的作品裁剪)
   *
   */
  osstransition(urlsize, imgurl, typeImg) {
    if (!imgurl) {
      return
    }
    let replaceState = '/watermark';
    let replacelater = urlsize + '/watermark';
    if (imgurl.indexOf('/watermark') != -1) {
      // console.log('imgurl.replace(replaceState,replacelater)',imgurl.replace(replaceState,replacelater)+',m_pad')
      // return  imgurl.replace(replaceState,replacelater)+',m_pad'
      if (typeImg == 1) {
        return imgurl = imgurl + urlsize + ',m_fill'
      } else {
        return imgurl = imgurl + urlsize + ',m_pad'
      }
    }
  },

  // 查询相关路径 key的关键字
  url2ParamObject() {
    console.log('window.location.href : ',window.location.href)
    let parts = window.location.href.split("?")
    if (parts.length < 2) return {}
    let [, paramsString] = parts
    let params = {}
    let arr = paramsString.split('&')
    for (let it of arr) {
      let [key, value = ''] = it.split('=')
      params[key] = decodeURIComponent(value)
    }
    console.log('params : ',params)
    return params
  },

  // 获取设备的信息
  getDeviceInfo() {
    let ua = JSON.parse(navigator.userAgent)
    let device = ua.device.toLowerCase()
    return {
      iOS: device.includes('iphone'),
      Android: device.includes('android')
    }
  },

}



// WEBPACK FOOTER //
// ./src/utils/utils.js